import { ResourcesConfig } from 'aws-amplify'

const cognitoUserPoolId = import.meta.env.PROD
  ? import.meta.env.VITE_APP_PROD_COGNITO_USER_POOL_ID
  : import.meta.env.VITE_APP_DEV_COGNITO_USER_POOL_ID

const cognitoClientId = import.meta.env.PROD
  ? import.meta.env.VITE_APP_PROD_COGNITO_CLIENT_ID
  : import.meta.env.VITE_APP_DEV_COGNITO_CLIENT_ID

/**
 * Custom Cognito endpoint, set only for local development against the Floci
 * emulator. Amplify and amazon-cognito-identity-js otherwise derive the
 * endpoint from the region in the user pool id, which always points at AWS.
 * Undefined everywhere else, so the AWS behaviour is unchanged.
 */
const cognitoEndpoint: string | undefined = import.meta.env?.VITE_APP_COGNITO_ENDPOINT

export const cognitoConfig = {
  userPoolId: cognitoUserPoolId,
  clientId: cognitoClientId,
  endpoint: cognitoEndpoint
}

export const appSyncConfig: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: import.meta.env?.VITE_APP_APP_SYNC_ENDPOINT,
      region: import.meta.env?.VITE_APP_APP_SYNC_REGION ?? 'eu-north-1',
      defaultAuthMode: import.meta.env?.VITE_APP_APP_SYNC_DEFAULT_AUTH_MODE ?? 'userPool'
    }
  },
  Auth: {
    Cognito: {
      userPoolId: cognitoUserPoolId,
      userPoolClientId: cognitoClientId,
      userPoolEndpoint: cognitoEndpoint,
      identityPoolId: import.meta.env?.VITE_APP_COGNITO_ID
    }
  }
}
